import { init } from "@sentry/browser";

export default function sentry() {
  if (process.env.REACT_APP_ENVIRONMENT !== "development") {
    init({
      dsn: process.env.REACT_APP_SENTRY_DNS,
      environment: process.env.REACT_APP_ENVIRONMENT
    })
  }
}